export default "__VITE_ASSET__2iseobuq__"